module.exports = __webpack_public_path__ + "assets/icon-shelter.5a1cbeee.svg";